import { gql } from '@apollo/client';

export const GET_DASHBOARD = gql`
  query GetProcessAreaWorkaroundsDashboard($locationUUID: ID!) {
    getProcessAreaWorkaroundsDashboard(locationUUID: $locationUUID) {
      uuid
      name
      revenue
      applicationsTagged
      completionPercentage
      type
      children {
        uuid
        name
        revenue
        applicationsTagged
        completionPercentage
        type
      }
    }
  }
`;

export const GET_PROCESS_AREA_OR_PROCESS_WORKAROUNDS = gql`
  query GetProcessAreaOrProcessWorkaround(
    $data: GetProcessAreaAndProcessWorkaroundsInput!
  ) {
    getProcessAreaOrProcessWorkaround(data: $data) {
      name
      locationName
      workarounds {
        processAreaOrProcessId
        itApplicationName
        itApplicationId
        locationId
        sla
        rto
        mto
        rpo
        isWorkaroundNeeded
        workaroundDefined
        runtimeHours
        maxDataLossHours
        workaroundDescription
        createdAt
        updatedAt
        workaroundUpdatedAt
        workaroundTimelineCompliance {
          slaCompliant
          rtoCompliant
          mtoCompliant
          rpoCompliant
        }
      }
    }
  }
`;

export const SET_PROCESS_AREA_OR_PROCESS_WORKAROUND = gql`
  mutation SetProcessAreaOrProcessWorkaround(
    $data: SetProcessAreaOrProcessWorkaroundInput!
  ) {
    setProcessAreaOrProcessWorkaround(data: $data)
  }
`;
